/**
 * Utilitaire pour générer un device fingerprint simple
 * Basé sur : User-Agent + Screen resolution + Timezone + Language + Cookie persistant
 */

const DEVICE_TOKEN_KEY = 'iptv_device_token';

/**
 * Génère ou récupère le device token depuis localStorage
 */
export const getDeviceToken = () => {
  // Vérifier si un token existe déjà
  let token = localStorage.getItem(DEVICE_TOKEN_KEY);
  
  if (!token) {
    // Générer un nouveau token basé sur les caractéristiques du device
    token = generateDeviceFingerprint();
    localStorage.setItem(DEVICE_TOKEN_KEY, token);
  }
  
  return token;
};

/**
 * Génère un fingerprint unique basé sur les caractéristiques du navigateur/device
 */
const generateDeviceFingerprint = () => {
  const components = [];
  
  // User Agent
  components.push(navigator.userAgent || 'unknown');
  
  // Screen resolution
  components.push(`${window.screen.width}x${window.screen.height}`);
  components.push(`${window.screen.colorDepth}`);
  
  // Timezone
  components.push(Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown');
  
  // Language
  components.push(navigator.language || 'unknown');
  
  // Platform
  components.push(navigator.platform || 'unknown');
  
  // Hardware concurrency (nombre de CPU)
  components.push(navigator.hardwareConcurrency || 'unknown');
  
  // Générer un hash simple (pas cryptographique, juste pour identifier)
  const fingerprint = components.join('|');
  const hash = simpleHash(fingerprint);
  
  // Ajouter un timestamp pour l'unicité
  const timestamp = Date.now();
  const randomPart = Math.random().toString(36).substring(2, 9);
  
  return `${hash}-${timestamp}-${randomPart}`;
};

/**
 * Fonction de hash simple (non cryptographique)
 */
const simpleHash = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convertir en 32bit integer
  }
  return Math.abs(hash).toString(36);
};

/**
 * Réinitialise le device token (utile pour le debug)
 */
export const resetDeviceToken = () => {
  localStorage.removeItem(DEVICE_TOKEN_KEY);
};

/**
 * Configure axios pour ajouter automatiquement le device token à chaque requête
 */
export const setupDeviceTracking = (axiosInstance) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const deviceToken = getDeviceToken();
      config.headers['X-Device-Token'] = deviceToken;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};
